module.exports = __webpack_public_path__ + "media/application/images/company/founders/Willie-McLucas-7249288537f64340be89b57335f43036.jpg";